export const fullShareLink = (key) => {
  return `${window.location.protocol}//${window.location.host}/s/${key}`;
}

export const fullJobFeedLink = (businessId) => {
  return `${window.location.protocol}//${window.location.host}/employers/${businessId}/jobs`;
}